const advisorChangelogState = {
  url: 'changelog/',
  data: {
    pageTitle: 'Feedback history'
  },
  template: `
  <advisor-edit-plan-header ng-if="$resolve.showEditHeader"></advisor-edit-plan-header>
  <advisor-header-view-plan ng-if="!$resolve.showEditHeader"></advisor-header-view-plan>
  <changelog></changelog>
  `
};

export const ApAdvisorChangelogRoutes = {
  'ap-advisor.changelog': { ...advisorChangelogState }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/advisor_routes/ap_advisor_changelog_routes.ts